import 'jquery';

export class Search {
    static get CLASS() { return 'unify-search'; }
    static get CLASS_BUTTON() { return 'unify-button-close'; }
    static get CLASS_STATE_DIRTY() { return 'unify-dirty'; }

    initialize(selector = '.' + Search.CLASS) {
        var $searchs = $(selector);
        $searchs.each(function (index, searchEl) {
            var $search = $(searchEl);
            var $input = $search.children('input');
            var $button = $search.children('.' + Search.CLASS_BUTTON);

            $input.on('input', function () {
                $search.toggleClass(Search.CLASS_STATE_DIRTY, '' !== $input.val());
            }.bind(this));

            if ($button.length > 0) {
                this._initializeClearButton($search, $input, $button);
            }

        }.bind(this));
    }

    _initializeClearButton($search, $input, $button) {
        $button.on('click', function () {
            if ($search.hasClass(Search.CLASS_STATE_DIRTY)) {
                $input.val('');
                $search.removeClass(Search.CLASS_STATE_DIRTY);
                $input.focus();
            }
        });
    }
}
